import * as React from "react";
import classnames from "classnames";
import StoreFinderItemContainer from "../../../StoreFinderItem/components/StoreFinderItem/StoreFinderItemContainer.js";
const PreferredStoreTile = ({ className, store, loading = false }) => /* @__PURE__ */ React.createElement(
  StoreFinderItemContainer,
  {
    className: classnames("stores-v2-preferred-store-tile", className),
    store,
    loading,
    variant: "bordered",
    isPreferredStore: true,
    showAttributesAsTags: true
  }
);
export {
  PreferredStoreTile as default
};
//# sourceMappingURL=PreferredStoreTile.js.map
